import { Box, Button, TablePagination } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonText } from 'src/components/ui/ButtonText';

interface Props {
  currentFilter: 'all' | 'messages' | 'voting';
  total: number;
  page: number;
  onPageChange: (page: number) => void;
  setCurrentFilter: (filter: 'all' | 'messages' | 'voting') => void;
  createNewVoting: () => void;
}

export const ForumHeader: FC<Props> = ({ total, page, currentFilter, setCurrentFilter, onPageChange, createNewVoting }) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '24px',
      }}
    >
      <div
        style={{
          display: 'flex',
          columnGap: '6px',
        }}
      >
        <ButtonText
          text={t('dashboard.assets.forum.filter.all')}
          selected={currentFilter === 'all'}
          onClick={() => setCurrentFilter('all')}
        />
        <ButtonText
          text={t('dashboard.assets.forum.filter.messages')}
          selected={currentFilter === 'messages'}
          onClick={() => setCurrentFilter('messages')}
        />
        <ButtonText
          text={t('dashboard.assets.forum.filter.voting')}
          selected={currentFilter === 'voting'}
          onClick={() => setCurrentFilter('voting')}
        />
      </div>

      <TablePagination
        component="div"
        count={total}
        page={page}
        onPageChange={(e, page) => onPageChange(page)}
        rowsPerPage={10}
        labelRowsPerPage=""
        rowsPerPageOptions={[]}
      />

      <Button variant="contained" color="primary" size="large" sx={{ mt: 2, marginTop: 0 }} onClick={createNewVoting}>
        {t('dashboard.assets.forum.createnewvoting')}
      </Button>
    </Box>
  );
};
